import React, { useState, useCallback } from 'react'
import address1 from '../../assets/img/connectUs/address1.jpg'
import address2 from '../../assets/img/connectUs/address2.jpg'
import address3 from '../../assets/img/connectUs/address3.jpg'
import time from '../../assets/img/icon/time.png'

export default function ConnectUs ({ bgImage, gradientColor }) {
  const [showMessage, setShowMessage] = useState(false)
  const handleMouseEnter = useCallback(() => setShowMessage(true), [])
  const handleMouseLeave = useCallback(() => setShowMessage(false), [])

  const getBgImage = () => {
    if (bgImage === 'blue') return address2
    if (bgImage === 'lightGreen') return address3
    if (bgImage === 'green') return address1
    return address1
  }

  return (
    <>
      <div
        className='flex flex-row mobile:flex-col justify-center items-center w-full rounded-2xl  h-[362px] tablet:mx-5
    tablet:mt-5 overflow-hidden mobile:hidden bg-cover bg-center tablet:hidden'
        style={{
          backgroundImage: `url(${getBgImage()})`
        }}
      >
        <div className='w-1/2 max-h-[362px] '></div>
        <div className='w-1/2 max-h-[362px] flex flex-row justify-start mobile:flex-col temp:mt-[-50px] mr-1'>
          <div className='flex flex-col justify-center tablet:mt-[-40px] mobile:w-full mobile:text-[12px] mobile:px-[20px] mobile:h-[300px]'>
            <h4 className='text-white opacity-70 text-[18px]'>Холбоо барих</h4>

            <div className='flex flex-row gap-2 mt-4 tablet:mt-2'>
              <p className='text-white opacity-70 text-[14px]'>Утас:</p>
              <span className='text-white text-[14px]'>77760000</span>
            </div>

            <div className='flex flex-row gap-2 text-[14px]'>
              <p className='text-white opacity-70'>Цахим шуудан:</p>
              <span className='text-white'>contact@cellclinic.mn</span>
            </div>

            <span className='text-white opacity-70 w-[500px] mt-[20px] mb-[20px] temp:mb-2 mobile:w-full text-[14px] tablet:mt-2 tablet:w-[400px] '>
              Монгол улс, Улаанбаатар хот, Чингэлтэй дүүрэг, 1-р хороо, Баруун
              сэлбийн гудамж, 5/26-р байр, Гандирс цогцолбор, III давхар
            </span>

            <button
              className='flex h-[40px] w-[140px] px-2 justify-center items-center text-[12px]
            gap-0 rounded-lg border border-[rgba(255,255,255,0.16)] bg-[rgba(255,255,255,0.16)] text-white'
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <img src={time} alt='Arrow Down' className='h-4 w-4 mr-2' />
              Цаг захиалах
            </button>

            {showMessage && (
              <p
                className='bg-[rgba(255,255,255,0.16)] w-[180px] text-[12px] text-white text-center
              absolute z-10 p-5 transform translate-x-1/2 left-[54%] mt-[200px] rounded-lg mobile:w-[160px] mobile:p-2'
              >
                Та цаг захиалах бол 77760000 дугаарт залгана уу.
              </p>
            )}
          </div>
        </div>
      </div>
      <div
        className={`hidden mobile:flex tablet:flex tablet:p-20 flex-col rounded-2xl ${
          gradientColor
            ? gradientColor
            : 'bg-gradient-to-l from-[#89D4E5] to-[#0C341E] '
        }`}
      >
        <div className='flex flex-col justify-center tablet:mt-[-40px] mobile:w-full mobile:text-[12px] mobile:px-[20px] mobile:h-[300px]'>
          <h4 className='text-white opacity-70 text-[18px]'>Холбоо барих</h4>

          <div className='flex flex-row gap-2 mt-4 tablet:mt-2'>
            <p className='text-white opacity-70 text-[14px]'>Утас:</p>
            <span className='text-white text-[14px]'>77760000</span>
          </div>

          <div className='flex flex-row gap-2 text-[14px]'>
            <p className='text-white opacity-70'>Цахим шуудан:</p>
            <span className='text-white'>contact@cellclinic.mn</span>
          </div>

          <span className='text-white opacity-70 w-[500px] mt-[20px] mb-[20px] mobile:w-full text-[14px] tablet:mt-2 tablet:w-[400px] '>
            Монгол улс, Улаанбаатар хот, Чингэлтэй дүүрэг, 1-р хороо, Баруун
            сэлбийн гудамж, 5/26-р байр, Гандирс цогцолбор, III давхар
          </span>

          <button
            className='flex h-[40px] w-[140px] px-2 justify-center items-center text-[12px]
            gap-0 rounded-lg border border-[rgba(255,255,255,0.16)] bg-[rgba(255,255,255,0.16)] text-white'
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <img src={time} alt='Arrow Down' className='h-4 w-4 mr-2' />
            Цаг захиалах
          </button>

          {showMessage && (
            <p
              className='bg-[rgba(255,255,255,0.16)] w-[180px] text-[12px] text-white text-center
              absolute z-10 p-5 left-[50%] transform -translate-x-1/2 mt-5 rounded-lg mobile:w-[160px] mobile:p-2'
            >
              Та цаг захиалах бол 77760000 дугаарт залгана уу.
            </p>
          )}
        </div>
      </div>
    </>
  )
}
